import { resetPassword } from './reducers';
export default resetPassword;
